export class looker {
  look_id: string;
  dashboard_id: string;
}
